import { LayoutState, PartData } from "../types/types"
import { createChevronLeftIcon, createCloseIcon, createInfoIcon, createModal, createRotateIcon } from "./createElemets"
import { LayoutsViewer } from "../ui/LayoutsViewer"
import { BASE_API_URL, LayoutsUploadModal } from "../layouts-upload-modal"
import { UploadZone } from "../ui/UploadZone"

// --------------------------------------------------------------------------------

export const createLayoutErrorsModal = (
    layoutState: LayoutState,
    index: number,
    root: ShadowRoot | null,
    layoutsViewer?: LayoutsViewer,
    uploadZone?: UploadZone
) => {

    const modal = document.createElement('div')
    modal.classList.add('layout-errors-container')
    modal.onclick = e => {
        e.stopPropagation()
        modal.classList.remove('visible')
        setTimeout(() => modal.remove(), 300)
    }

    const container = document.createElement('div')
    container.onclick = e => {
        e.stopPropagation()
    }

    modal.append(container)
    root?.append(modal)
    setTimeout(() => modal.classList.add('visible'))

    if (!layoutState || !layoutState.checkResData) return

    const checkDataResult = Object.values(layoutState.checkResData.result)[0]

    // ----------

    const title = document.createElement('div')
    title.classList.add('title')

    const previewImg = new Image()
    previewImg.src = BASE_API_URL + (Object.values(checkDataResult.pages[0])[0].preview ?? layoutState.uploadResData.preview)
    previewImg.alt = 'layout-preview'
    previewImg.classList.add('preview-img')

    const h3 = document.createElement('h3')
    h3.textContent = layoutState.uploadResData.original_name

    const layoutTitle = document.createElement('span')
    layoutTitle.textContent = layoutState.partData.name

    const info = document.createElement('span')
    info.textContent = 'Исправьте замечания прежде чем загружать в макет'

    const btnContainer = document.createElement('div')
    btnContainer.classList.add('btn-container')

    const replaceLayoutBtn = document.createElement('button')
    replaceLayoutBtn.classList.add('replace-btn')
    replaceLayoutBtn.type = 'button'
    replaceLayoutBtn.textContent = 'Заменить макет'
    replaceLayoutBtn.onclick = () => createModal({
        title: 'Вы уверены что хотите заменить?',
        subTitle: 'Вы вернетесь в режим проверки и загрузки макетов, этот макет будет удален',
        submitText: 'Да, заменить',
        cancelText: 'Отменить',
        action: () => {

            let temp = layoutsState[layoutState.partData.id].slice()
            temp[index] = null
            layoutsState[layoutState.partData.id] = temp

            const uploadModal = layoutsUploadModal as LayoutsUploadModal

            if (uploadModal.twoSidePdf) {
                uploadModal.uploadZones[0].clearState()
                uploadModal.uploadZones[1].clearState()

                uploadModal.twoSidePdf = false
            } else
                uploadZone?.clearState()

            layoutsViewer?.closeModal()

            if (uploadModal.step !== 1) uploadModal.step = 1

            modal.classList.remove('visible')
            setTimeout(() => modal.remove(), 300)
        }
    }, root)
    replaceLayoutBtn.prepend(createRotateIcon())

    btnContainer.append(replaceLayoutBtn)

    title.append(previewImg, h3, layoutTitle, info, btnContainer)

    // ----------

    const table = document.createElement('div')
    table.classList.add('table')

    const thead = document.createElement('div')
    thead.classList.add('thead')

    const params = ['Параметр', 'Требования', 'В макете']
    params.forEach(param => {
        const theadParam = document.createElement('div')
        theadParam.textContent = param
        thead.append(theadParam)
    })

    const bodies = document.createElement('div')
    bodies.classList.add('tbodies')

    table.append(thead, bodies)

    const errorObjects = Object.entries(checkDataResult.errors)
    const multipleTables = errorObjects.length > 1

    errorObjects.forEach(([index, errors]) => {

        const tbody = document.createElement('div')
        tbody.classList.add('tbody')

        if (multipleTables) {
            tbody.classList.add('multiple')

            const span = document.createElement('span')
            span.classList.add('page')
            span.textContent = 'Страница ' + index
            tbody.append(span)
        }

        errors.forEach(error => {

            const tr = document.createElement('div')
            tr.classList.add('tr')
            if (error.actionId === 1)
                tr.classList.add('hidden')

            const label = document.createElement('div')
            label.textContent = error.label

            if (error.actionId === 1)
                label.append(createInfoIcon('ok'))

            if (error.actionId === 2)
                label.append(createInfoIcon('warning'))

            if (error.actionId === 3)
                label.append(createInfoIcon('error'))

            label.onclick = e => tr.classList.toggle('hidden')

            const requireValue = document.createElement('div')
            requireValue.textContent = error.requireValue
            const requireValueSpan = document.createElement('span')
            requireValueSpan.textContent = 'Требования'
            requireValue.prepend(requireValueSpan)

            const value = document.createElement('div')

            const valueContainer = document.createElement('div')
            valueContainer.classList.add('value-container')
            valueContainer.textContent = error.value

            const iconContainer = document.createElement('div')
            iconContainer.classList.add('icon-container')
            setTimeout(() => {
                const parent = iconContainer.offsetParent as HTMLDivElement | null
                if (parent && parent.offsetWidth - iconContainer.offsetLeft < 250) {
                    iconContainer.classList.add('right')
                }
            })

            if (error.actionId === 2) {
                iconContainer.append(createInfoIcon('warning'))
                valueContainer.classList.add('warning')
            }

            if (error.actionId === 3) {
                iconContainer.append(createInfoIcon('error'))
                valueContainer.classList.add('error')
            }

            if (error.desc) {
                const tooltip = document.createElement('div')
                tooltip.classList.add('tooltip')
                tooltip.textContent = error.desc

                iconContainer.append(tooltip)
            }

            valueContainer.append(iconContainer)

            const valueSpan = document.createElement('span')
            valueSpan.textContent = 'В макете'
            value.append(valueSpan, valueContainer)

            const chevronIcon = createChevronLeftIcon()
            chevronIcon.onclick = () => tr.classList.toggle('hidden')

            tr.append(label, requireValue, value, chevronIcon)
            tbody.append(tr)
        })

        bodies.append(tbody)
    })

    const closeBtn = document.createElement('button')
    closeBtn.classList.add('close')
    closeBtn.append(createCloseIcon('var(--gray-800, #2D3748)'))

    const closeBtnSpan = document.createElement('span')
    closeBtnSpan.textContent = 'К файлам'
    closeBtnSpan.prepend(createChevronLeftIcon())
    closeBtn.append(closeBtnSpan)

    closeBtn.onclick = () => {
        modal.classList.remove('visible')
        setTimeout(() => modal.remove(), 300)
    }

    container.append(title, table, closeBtn)
}